export default "__VITE_ASSET__qgSesZXR__"